import React, { useState, useEffect } from "react";
import HouseService from "../../services/houseService";
import HouseItem from "../houses/HouseItem";
import { useNavigate } from "react-router-dom";
import { IconHomeSearch } from "@tabler/icons-react";

const Recents = () => {
  const [saleHouses, setSaleHouses] = useState([]);
  const [rentHouses, setRentHouses] = useState([]);
  const houseService = HouseService();
  const navigate = useNavigate();
  const saleHouses_offline = [
    {
      images: [{ imageName: "img/h7.webp" }, { imageName: "img/h2.webp" }],
      houseStatus: "En Venta",
      title: "Casa en Condina",
      price: 150000000,
      rooms: 5,
      parking: 1,
      baths: 3,
      squaremts: 90,
      houseDescription:
        "Ven y conoce esta hermosa casa para compartir en familia.",
    },
    {
      images: [{ imageName: "img/h2.webp" }],
      houseStatus: "En Venta",
      title: "Casa en Cerritos",
      price: 270000000,
      rooms: 4,
      parking: 2,
      baths: 3,
      squaremts: 140,
      houseDescription:
        "Ven y conoce esta hermosa casa para compartir en familia.",
    },
    {
      images: [{ imageName: "img/h8.webp" }],
      houseStatus: "En Venta",
      title: "Casa en Pinares",
      price: 350000000,
      rooms: 7,
      parking: 3,
      baths: 5,
      squaremts: 200,
      houseDescription:
        "Ven y conoce esta hermosa casa para compartir en familia.",
    },
  ];
  const rentHouses_offline = [
    {
      images: [{ imageName: "img/h4.webp" }, { imageName: "img/h6.webp" }],
      houseStatus: "Para Arrendar",
      title: "Casa en Condina",
      price: 1500000,
      rooms: 5,
      parking: 1,
      baths: 3,
      squaremts: 90,
      houseDescription:
        "Ven y conoce esta hermosa casa para compartir en familia.",
    },
    {
      images: [{ imageName: "img/h5.webp" }],
      houseStatus: "Para Arrendar",
      title: "Casa en Cerritos",
      price: 2700000,
      rooms: 4,
      parking: 2,
      baths: 3,
      squaremts: 140,
      houseDescription:
        "Ven y conoce esta hermosa casa para compartir en familia.",
    },
    {
      images: [{ imageName: "img/h8.webp" }],
      houseStatus: "Para Arrendar",
      title: "Casa en Pinares",
      price: 3500000,
      rooms: 7,
      parking: 3,
      baths: 5,
      squaremts: 200,
      houseDescription:
        "Ven y conoce esta hermosa casa para compartir en familia.",
    },
  ];

  useEffect(() => {
    const fetchHouses = async () => {
      try {
        const response = await houseService.getSaleHouses();
        //console.log(response);
        setSaleHouses(response);

        const response2 = await houseService.getRentHouses();
        setRentHouses(response2);
      } catch (error) {
        console.error("Error fetching houses:", error);
      }
    };

    fetchHouses(); // Call the function to fetch houses
  }, []);

  const goProperties = () => {
    navigate("/properties");
  }; // Empty dependency array to run once on mount

  return (
    <div className="recents">
      <div className="recents-header">
        <div className="recents-searchBar">
          <IconHomeSearch stroke={2} />
          <input type="text" placeholder="Encuentra tu inmueble" />
        </div>
      </div>
      <div className="recenets-sales recent-section">
        <div>
          <h2>En venta</h2>
        </div>
        <div className="recent-house-cards-container">
          {Array.isArray(saleHouses) && saleHouses.length > 0
            ? saleHouses.map((house, index) => (
                <HouseItem key={index} house={house} />
              ))
            : saleHouses_offline.map((house, index) => (
                <HouseItem key={index} house={house} />
              ))}
        </div>
        <div className="recent-plus-button">
          <button onClick={goProperties}>Ver más</button>
        </div>
      </div>
      <div className="recents-rent recent-section">
        <div>
          <h2>Rentar</h2>
        </div>
        <div className="recent-house-cards-container">
          {Array.isArray(rentHouses) && rentHouses.length > 0
            ? rentHouses.map((house, index) => (
                <HouseItem key={index} house={house} />
              ))
            : rentHouses_offline.map((house, index) => (
                <HouseItem key={index} house={house} />
              ))}
        </div>
        <div className="recent-plus-button">
          <button onClick={goProperties}>Ver más</button>
        </div>
      </div>
      <div className="recents-adivce recent-section">
        <div>
          <h2>Asesorías</h2>
        </div>
        <div className="recent-house-cards-container">
          <div className="house-card">
            <div className="house-card-images-container">
              <img
                src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="asesoria 1"
              />
            </div>
            <div className="house-card-top">
              <h2>Asesoría de Ventas</h2>
              <p>Excelente servicio para ayudarte alcanzar tus metas</p>
            </div>
          </div>
          <div className="house-card">
            <div className="house-card-images-container">
              <img
                src="https://images.unsplash.com/photo-1551836022-4c4c79ecde51?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="asesoria 1"
              />
            </div>
            <div className="house-card-top">
              <h2>Asesoría de Ventas</h2>
              <p>Excelente servicio para ayudarte alcanzar tus metas</p>
            </div>
          </div>
          <div className="house-card">
            <div className="house-card-images-container">
              <img
                src="https://images.unsplash.com/photo-1551135049-8a33b5883817?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="asesoria 1"
              />
            </div>
            <div className="house-card-top">
              <h2>Asesoría de Ventas</h2>
              <p>Excelente servicio para ayudarte alcanzar tus metas</p>
            </div>
          </div>
        </div>
      </div>

      <div className="recent-plus-button">
        <button onClick={goProperties}>Ver más</button>
      </div>
    </div>
  );
};
export default Recents;
